import { useState } from 'react';

export type DrawerView = 'settings' | 'volume' | 'share' | undefined;

export function useEdtDrawers() {
  const [drawerView, setDrawerView] = useState<DrawerView>();

  const openDrawer = (view: string) => {
    setDrawerView(view as DrawerView);
  };

  const closeDrawer = () => {
    setDrawerView(undefined);
  };

  return {
    drawerView,
    openDrawer,
    closeDrawer,
    setDrawerView,
  };
}
